export default __webpack_public_path__ + "static/media/folkes_map_new.586d5fcb.png";